/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Compare_OverviewsInputs */

const en_why_listening_compare_overviews = /** @type {(inputs: Why_Listening_Compare_OverviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI overviews and key points`)
};

const es_why_listening_compare_overviews = /** @type {(inputs: Why_Listening_Compare_OverviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resúmenes con IA y puntos clave`)
};

/**
* | output |
* | --- |
* | "AI overviews and key points" |
*
* @param {Why_Listening_Compare_OverviewsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_compare_overviews = /** @type {((inputs?: Why_Listening_Compare_OverviewsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Compare_OverviewsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_compare_overviews(inputs)
	return en_why_listening_compare_overviews(inputs)
});